/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-28 13:59:38
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-16 11:32:49
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * getBusinessApprovalList
   * @description 合同列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getAdminBusinessApprovalList(data) {
    return request.get(`${BASE_URL}/trade_project/list`, data)
  },
  /**
   * saveBusinessApproval
   * @description 保存合同
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveAdminBusinessApprovalAudit(data) {
    return request.post(`${BASE_URL}/trade_project/store`, data)
  },
  /**
   * deleteBusinessApproval
   * @description 删除合同
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteAdminBusinessApproval(id) {
    let data = {id:id}
    return request.post(`${BASE_URL}/admin_bill/delete`, data)
  },
}